import React from 'react'
import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import { CONTROL, RADIUS } from '../../theme/tokens'

/**
 * Compact pill toggle (replaces MUI Switch, whose small-size thumb clips
 * outside the track). Keyboard-accessible: Space/Enter toggles.
 */
const PillToggle = ({ checked, onChange, label, disabled = false }) => {
    const toggle = () => !disabled && onChange(!checked)
    return (
        <Box
            role="switch"
            aria-checked={checked}
            aria-disabled={disabled || undefined}
            aria-label={label}
            tabIndex={disabled ? -1 : 0}
            onClick={toggle}
            onKeyDown={(e) => {
                if (e.key === ' ' || e.key === 'Enter') {
                    e.preventDefault()
                    toggle()
                }
            }}
            sx={{
                width: 34,
                height: 19,
                borderRadius: `${RADIUS.pill}px`,
                position: 'relative',
                flexShrink: 0,
                cursor: disabled ? 'not-allowed' : 'pointer',
                background: checked ? CONTROL.trackOn : CONTROL.trackOff,
                opacity: disabled ? 0.5 : 1,
                transition: 'background 0.18s ease',
                outline: 'none',
                '&:focus-visible': {
                    boxShadow: `0 0 0 2px ${CONTROL.focusRing}`,
                },
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    top: 2,
                    left: checked ? 17 : 2,
                    width: 15,
                    height: 15,
                    borderRadius: '50%',
                    background: CONTROL.knob,
                    transition: 'left 0.18s ease',
                },
            }}
        />
    )
}

PillToggle.propTypes = {
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
}

export default PillToggle
